module.exports = __webpack_public_path__ + "static/rbc-d70d3b6aa7a42374c83eaa0e00d22808.jpg";